export default __webpack_public_path__ + "static/iceland-blue-lagoon-credit-Moyan-Brenn-401246f57258f54083f1cb0a67dd8542.jpg";